<template>
  <div class="site">
    <header>
      <AppLogo />
      <div class="stepper">
        <slot name="stepper"></slot>
      </div>
    </header>
    <aside>
      <div class="intro">
        <slot name="intro"></slot>
      </div>

      <div v-if="showEditor">
        <strong class="editor-header">{{editorHeader}}</strong>
        <div class="editor">

          <div class="code-box code-box--css" :style="{height:editorHeight}">
            <div class="line-numbers">
              1<br>2<br>3<br>4<br>5<br>6<br>7<br>8<br>9<br>10<br>11<br>12<br>13<br>14<br>15<br>16<br>17<br>18<br>19<br>20
            </div>
            <slot name="cssInput"></slot>
          </div>
        </div>
      </div>
      <button class="btn btn-primary" @click="next">
        Næste
      </button>
    </aside>
    <main>
      <slot name="output"></slot>
    </main>
    <footer>
    </footer>
  </div>
</template>

<script>
import AppLogo from '@/components/AppLogo'
export default {
  name: 'TheBaseGrid',
  components: {
    AppLogo
  },
  props: {
    showEditor: {
      type: Boolean
    },
    editorHeader: {
      type: String,
      default: 'CSS'
    },
    editorHeight: {
      type: String,
      default: '260px'
    }
  },
  data() {
    return {
      htmlContent: "Overskrift",
      cssContent: "",
    }
  },
  methods: {
    checkInput(){
      if(window.getComputedStyle(document.querySelector('h1')).color !== 'rgb(51, 51, 51)'){
        alert("Du gjorde det gå til næste bane");
      }
    },
    next() {
      this.$emit('next');
    }
  }
}
</script>
